/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ClockRotateLeftIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M7 10.669V7.5C7 6.669 6.331 6 5.5 6S4 6.669 4 7.5v7c0 .831.669 1.5 1.5 1.5h7c.831 0 1.5-.669 1.5-1.5s-.669-1.5-1.5-1.5H9.044C11.356 9.387 15.4 7 20 7c7.181 0 13 5.819 13 13s-5.819 13-13 13a12.9 12.9 0 0 1-7.169-2.156 1.507 1.507 0 0 0-2.081.418 1.5 1.5 0 0 0 .419 2.082A15.9 15.9 0 0 0 20 36c8.837 0 16-7.163 16-16S28.837 4 20 4C14.644 4 9.9 6.631 7 10.669M20 12c-.831 0-1.5.669-1.5 1.5V20c0 .4.156.781.438 1.063l4.5 4.5a1.5 1.5 0 0 0 2.119-2.119l-4.063-4.063V13.5c0-.831-.669-1.5-1.5-1.5z"/>}
        </IconWrapper>);
}
